// extracted by mini-css-extract-plugin
module.exports = {"conFirmSendStyle":"_3kCuOFa0eP-PjQ-XV2kaPE"};